<ng-container *ngIf="message">
  <br>
  <div class="alert {{ message.type }}" role="alert">
    {{ message.text }}
  </div>
</ng-container>
